import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

export default function Login() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img src="https://images.pexels.com/photos/16571735/pexels-photo-16571735.jpeg" alt="clinic" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/55" />
        <div className="absolute bottom-0 p-12 text-white">
          <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-primary px-4 py-1.5 text-sm font-medium">
            <Sparkles size={15} /> R&D Innovation Hub
          </div>
          <h2 className="font-head text-4xl font-extrabold leading-tight tracking-tight">
            Track innovation.<br />Benchmark the best.<br />Ship what matters.
          </h2>
          <p className="mt-3 max-w-md text-slate-200">Strategic goals, R&D pipeline, competitor intelligence & client feedback — for Youngness Center & Awish Clinic.</p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm text-center">
          <div className="mb-8 flex items-center justify-center gap-2">
            <div className="grid h-10 w-10 place-items-center rounded-lg bg-primary text-white"><Sparkles size={20} /></div>
            <span className="font-head text-lg font-extrabold">Youngness · Awish</span>
          </div>
          <h1 className="font-head text-2xl font-bold tracking-tight">Welcome</h1>
          <p className="mb-8 text-sm text-muted-foreground">Sign in to your R&D workspace to continue.</p>

          <Button onClick={signIn} className="w-full h-11 gap-2" data-testid="google-login-btn">
            <svg width="18" height="18" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6.1 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.3-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.6 6.1 29.6 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.5 0 10.5-2.1 14.3-5.6l-6.6-5.6C29.6 34.6 26.9 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.6 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.6 5.6C42.7 35.9 44 30.4 44 24c0-1.3-.1-2.3-.4-3.5z"/></svg>
            Continue with Google
          </Button>
          <p className="mt-6 text-xs text-muted-foreground">By continuing you agree to use this internal R&D workspace responsibly.</p>
        </div>
      </div>
    </div>
  );
}
